module.exports = __webpack_public_path__ + "static/media/schedule_structure_set_rotating_periods.ab9e9fb6.mov";